export default __webpack_public_path__ + "images/loader.f9fce53abac458739dfb7c58ebe2db9d.svg";